import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, computed, effect, inject, input, Input, OnChanges, OnInit, signal, SimpleChanges, ChangeDetectorRef, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { IItem } from '../../models/IItem';
import { IFilterState } from '../../models/IFilterState';
import { ItemsComponent } from '../items/items.component';
import { PaginatorModule } from 'primeng/paginator';
import { HeaderComponent } from '../auctions/header/header.component';
import { FooterComponent } from '../auctions/footer/footer.component';
import { AccordionModule } from 'primeng/accordion';
import { TextareaModule } from 'primeng/textarea';
import { TabsModule } from 'primeng/tabs';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ApiService } from '../../services/api.service';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { environment } from '../../../environments/environment';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MD_BREAKPOINT } from '../../constants';
import { InputGroupModule } from 'primeng/inputgroup';
import { distinctUntilChanged, skip, Subscription } from 'rxjs';
import { AuthService } from '../../services/authentication/auth.service';
import { ItemSearchComponent } from './item-search/item-search.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ModalService } from '../../services/modals/modal.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faImage, faList, faShareFromSquare } from '@fortawesome/free-solid-svg-icons';
import { PaginatorStateService } from '../../services/paginator/paginator-state.service';
import { ActivatedRoute } from '@angular/router';
import { SelectButton } from 'primeng/selectbutton';
import { SearchBarComponent } from "../auctions/items/search-bar/search-bar.component";
import { ThemeService } from '../../services/theme.service';


@Component({
  selector: 'app-item-list',
  imports: [FormsModule,
    SelectModule,
    ButtonModule,
    ProgressBarModule,
    ItemsComponent,
    CommonModule,
    PaginatorModule,
    HeaderComponent,
    FooterComponent,
    AccordionModule,
    TextareaModule,
    TabsModule,
    DialogModule,
    InputGroupModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    MultiSelectModule,
    ItemSearchComponent,
    ProgressSpinnerModule,
    FontAwesomeModule,
    SelectButton,
    SearchBarComponent,
  ],
  providers: [DynamicDialogRef],
  templateUrl: './item-list.component.html',
  styleUrl: './item-list.component.scss'
})
export class ItemListComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  private themeService = inject(ThemeService);
  isActive: string = '';
  bidLabelItem: string = '';
  selectCategory: any = null;
  selectedSort: string = '';

  @Input() id?: number;
  query = input('');
  sort = input('');
  view = input('');

  // Deprecated -> use categoriesQ instead - can be deleted in the future
  categories = input('');

  categoriesQ = input('');
  dynamicCategory = input('');

  customImage: string = '';

  selectedItem = signal<IItem | null>(null);

  //ckeckbox Properties
  chkAgreeTerms: boolean = false;
  chkAutoBid: boolean = false;
  isCommunityTheme: any;

  ItemListOptions: any[] = [{ label: 'Image View', value: 'image' }, { label: 'List View', value: 'list' }];


  //Paginator
  page: number = 0;
  rowsPerPage: number = 30;

  rowsPerPageOptions = [15, 30, 60, 90];
  paginatedItems: any[] = [];
  itemList: IItem[] = [];

  // Modal 
  displayModal: boolean = false;
  selectedItemId!: number;
  filteredTab: { value: number, title: string }[] = [];
  itemModal: IItem | null = null;
  isModalOpen: boolean = true;
  itemsReload!: boolean;
  authSubscription!: Subscription;
  authService = inject(AuthService);
  activeRoute = inject(ActivatedRoute);

  //search
  showSearchView: boolean = false;
  inputSearch: string | null = null;
  searchQuery: string | null = null;
  searchCounter = signal(0);

  oidcSecurityService = inject(OidcSecurityService);
  isAuthenticated = this.oidcSecurityService.authenticated;

  private readonly apiService = inject(ApiService)
  modalService = inject(ModalService);
  paginatorService = inject(PaginatorStateService);


  sortFilters = [
    { label: 'Item Name - Descending', value: 'NAME_DESC' },
    { label: 'Item Name - Ascending', value: 'NAME_ASC' },
    { label: 'Lot Number - Descending', value: 'LOT_DESC' },
    { label: 'Lot Number - Ascending', value: 'LOT_ASC' },
    { label: 'Value - Ascending', value: 'VALUE_ASC' },
    { label: 'Value- Descending', value: 'VALUE_DESC' },
    { label: 'Leading Bid - Ascending', value: 'HIGHBID_ASC' },
    { label: 'Leading Bid - Descending', value: 'HIGHBID_DESC' },
    { label: 'Time Left - Ascending', value: 'TIMELEFT_ASC' },
    { label: 'Time Left - Descending', value: 'TIMELEFT_DESC' },
  ];

  protected icons = {
    faImage: faImage,
    faList: faList,
    faShareFromSquare: faShareFromSquare,
  }

  auctionConfigSignal = this.apiService.auctionConfigSignal;

  protected defaultItemsSort = computed(() =>
    this.apiService.auctionConfigSignal()?.defaultItemsSort ?? 'NAME_DESC'
  );

  protected defaultItemsView = computed(() =>
    (this.apiService.auctionConfigSignal()?.defaultItemsView?.toLowerCase() as 'image' | 'list') ?? 'image'
  );

  viewMode: 'image' | 'list' = 'image';

  selectedSortSignal = signal(this.defaultItemsSort());


  items = computed(() => this.apiService.itemsSignal().items);
  isLoadingListing = computed(() => this.apiService.isLoadingListing());
  totalItemsSignal = computed(() => this.apiService.itemsSignal().totalItems);

  categoryFilters = computed(() => this.apiService.categoryFilters());

  paginatorReady!: boolean;

  // Signal store filters
  filters = signal<IFilterState>({
    sort: this.defaultItemsSort(),
    categoryId: [] as number[],
    page: 1,
    per: 30,
    q: '',
    dynamicCategory: ''
  });

  dynamicCategories = computed(() =>
    Object.entries(this.apiService.dynamicCategoriesSignal()).map(([key, value]) => ({
      label: value,
      value: key,
    }))
  );

  isItemCategoryListEnabled = computed(
    () => this.apiService.auctionConfigSignal()?.isItemCategoryListEnabled
  );

  mobileCategoriesOpen = signal(false);

  mobileCategoryLabel = computed(() => {
    const { categoryId, dynamicCategory } = this.filters();
    if (dynamicCategory) {
      const label = this.dynamicCategories().find(c => c.value === dynamicCategory)?.label ?? '';
      return label ? `: ${label}` : '';
    }
    const id = categoryId[0];
    if (!id) return '';
    const label = this.categoryFilters().find(c => c.value === id)?.label ?? '';
    const name = label.replace(/\s*\(\d+\)\s*$/, '');
    return name ? `: ${name}` : '';
  });

  baseItemCount = signal<number>(0);

  sidebarRegularCategories = computed(() =>
    this.categoryFilters().filter(cat => {
      const match = cat.label.match(/\((\d+)\)$/);
      return !match || parseInt(match[1], 10) > 0;
    })
  );

  sidebarSmartCategories = computed(() =>
    this.dynamicCategories().filter(cat =>
      cat.label.toLowerCase() !== 'closed items'
    )
  );

  closedItemsEntry = computed(() =>
    this.dynamicCategories().find(cat => cat.label.toLowerCase() === 'closed items')
  );

  closedFilteredItems = computed(() =>
    (this.items() ?? [])
      .map(item => ({
        ...item,
        imageUrl: item.imageUrl?.trim().toLowerCase() !== 'null' && item.imageUrl?.trim()
          ? item.imageUrl.trim()
          : '/item-default.jpg',
      }))
      .filter(item => item.biddingType !== 'BUY_NOW_ONLY' && item.biddingType !== 'LIVE_ONLY')
  );

  showClosedItems = computed(() => !!this.closedItemsEntry());

  // Human-readable name of the active category filter, used for the empty-results message.
  selectedCategoryName = computed(() => {
    const { categoryId, dynamicCategory } = this.filters();

    if (dynamicCategory) {
      return this.dynamicCategories().find(c => c.value === dynamicCategory)?.label ?? '';
    }

    if (categoryId.length) {
      return categoryId
        .map(id => this.categoryFilters().find(c => c.value === id)?.label ?? '')
        .filter(Boolean)
        .map(label => label.replace(/\s*\(\d+\)\s*$/, '')) // strip the "(count)" suffix
        .join(', ');
    }

    return '';
  });

  protected showShareModal = signal(false);
  protected linkCopied = signal(false);

  protected openShareModal(): void {
    this.showShareModal.set(true);
  }

  protected copyShareableUrl(): void {
    navigator.clipboard.writeText(this.shareableUrl()).then(() => {
      this.linkCopied.set(true);
      setTimeout(() => this.linkCopied.set(false), 5000);
    });
  }

  protected shareableUrl = computed(() => {
    if (!isPlatformBrowser(this.platformId)) {
      return '';
    };
    const { categoryId, q, dynamicCategory } = this.filters();
    const url = new URL(window.location.protocol + window.location.host + window.location.pathname);
    if (categoryId !== undefined && categoryId.length > 0) {
      url.searchParams.set('categoriesQ', this.toUrlSafeBase64(JSON.stringify(categoryId)));
    } else if (dynamicCategory !== undefined && dynamicCategory !== '') {
      url.searchParams.set('dynamicCategory', dynamicCategory);
    }
    if (q !== undefined && q !== '') {
      url.searchParams.set('query', q);
    }
    return url.href;
  });

  firstSignal = signal(0);
  // It is automatically recalculated when a change occurs on the page.
  pagination = this.paginatorService.getPagination();

  constructor(private cdr: ChangeDetectorRef) {

    effect(() => {
      const total = this.totalItemsSignal();
      const f = this.filters();
      if (total > 0 && !f.categoryId.length && !f.dynamicCategory && !f.q) {
        this.baseItemCount.set(total);
      }
    });

    effect(() => {

      const isModalOpen = this.modalService.modalOpen();
      const withValue = this.items();

      if (withValue) {
        this.itemList = this.filters().dynamicCategory === 'CLOSED'
          ? this.closedFilteredItems()
          : withValue.map(item => ({
              ...item,
              imageUrl: item.imageUrl?.trim().toLowerCase() !== 'null' && item.imageUrl?.trim()
                ? item.imageUrl.trim()
                : '/item-default.jpg',
            }));
        this.cdr.detectChanges();
      }

      const itemsFound = this.totalItemsSignal();
      const loading = this.isLoadingListing();
      const trigger = this.searchCounter();

      const first = this.firstSignal();

      if (itemsFound > 0) {
        this.showSearchView = false;
      } else {
        this.showSearchView = true;
        this.searchQuery = this.inputSearch ?? null;
      }

    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && this.id != undefined) {
      this.themeService.customizeAuctionTheme(this.id);
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        this.viewMode = window.innerWidth < 1200
          ? 'image'
          : (this.viewMode ?? 'image');
      });

      //populate event page signal
      if (!this.apiService.homePageSignal()) {
        const endpoint = 'auctions';
        this.apiService.getAuctionHomePageData(endpoint, this.id!);
        localStorage.setItem('homePageData', JSON.stringify(this.apiService.homePageSignal()));
      }


      if (Object.keys(this.apiService.dynamicCategoriesSignal()).length === 0) {
        this.apiService.getCategories(this.id!).subscribe();
      }
    }

    this.apiService.getAuctionConfig(this.id!).subscribe({
      next: () => this.initializeFiltersAndLoadItems(),
      error: () => this.initializeFiltersAndLoadItems(),
    });

    this.authSubscription = this.authService.isAuthenticated$
      .pipe(distinctUntilChanged(), skip(1))
      .subscribe(isAuth => {
        if (!isAuth) {
          this.authService.creditCardSignal.set(null);
        }
        this.apiService.getItemList('auctions', this.id!, this.filters()).subscribe();
      });
  }

  private initializeFiltersAndLoadItems() {
    let storedFilters = this.paginatorService.getFilters();

    // Persisted filters are scoped to the auction they were created in.
    // If they belong to a different auction, discard them so we don't apply
    // category IDs (or sort/search/pagination) that don't exist here, which
    // would produce an empty, label-less result.
    const hasStoredForThisAuction = !!storedFilters && storedFilters.auctionId === this.id;
    if (storedFilters && !hasStoredForThisAuction) {
      this.paginatorService.clearFilters();
      this.paginatorService.setPagination(1, 30);
      storedFilters = null;
    }

    const pagination = this.paginatorService.getPagination() ?? { page: 1, per: 30 };
    const query = this.query();
    const sortParam = this.sort();
    const viewParam = (this.view() || '').toLowerCase();
    const categories = (this.categoriesQ() !== undefined && this.categoriesQ() !== '')
      ? JSON.parse(this.fromUrlSafeBase64(this.categoriesQ()))
      : (this.categories() !== undefined && this.categories() !== '')
        ? JSON.parse(this.categories())
        : [];

    // Precedence: URL param > stored filter (sessionStorage) > auction config default.
    const sort = sortParam || storedFilters?.sort || this.defaultItemsSort();
    const categoryId = categories.length !== 0 ? categories : storedFilters?.categoryId ?? [];
    const dynamicCategory = this.dynamicCategory() !== '' ? this.dynamicCategory() : storedFilters?.dynamicCategory ?? '';
    const q = query !== '' ? query : '';

    this.selectedSortSignal.set(sort);
    if (q) {
      this.inputSearch = q;
    }

    if (typeof window !== 'undefined') {
      if (viewParam === 'image' || viewParam === 'list') {
        this.viewMode = viewParam;
      } else {
        this.viewMode = window.innerWidth < 1200
          ? 'image'
          : this.defaultItemsView();
      }
    }

    const initialFilters: IFilterState = {
      sort,
      categoryId,
      page: pagination.page,
      per: pagination.per,
      q,
      dynamicCategory,
      auctionId: this.id,
    };

    this.filters.set(initialFilters);
    this.firstSignal.set((pagination.page - 1) * pagination.per);
    this.pagination = pagination;
    this.paginatorReady = true;

    this.apiService.getItemList('auctions', this.id!, initialFilters).subscribe();
  }

  resetFilters() {
    this.filters.set({
      sort: this.defaultItemsSort(),
      categoryId: [],
      page: 1,
      per: 30,
      q: '',
      dynamicCategory: '',
      auctionId: this.id
    });
  }


  onSortChange(event: any): void {
    this.selectedSortSignal.set(event.value);

    if (this.filters().sort !== event.value) {
      this.filters.update(filters => {
        const updatedFilters = {
          ...filters,
          sort: event.value,
          page: 1
        };
        this.paginatorService.setFilters(updatedFilters);

        const first = (updatedFilters.page - 1) * updatedFilters.per;
        this.firstSignal.set(first);
        return updatedFilters;

      });

      const endpoint = 'auctions';
      this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
    }


  }

  onCategoryChange(selectedCategories: number[]): void {

    this.filters.update(filters => {
      const updateFilters = {
        ...filters,
        categoryId: selectedCategories,
        page: 1,
        dynamicCategory: ''
      };

      this.paginatorService.setFilters(updateFilters);

      const first = (updateFilters.page - 1) * updateFilters.per;
      this.firstSignal.set(first);
      return updateFilters;
    });

    const endpoint = 'auctions';
    this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
  }

  toggleMobileCategoryPanel(): void {
    this.mobileCategoriesOpen.update(open => !open);
  }

  selectCategoryFromSidebar(categoryId: number): void {
    const current = this.filters().categoryId;
    const updated = current[0] === categoryId ? [] : [categoryId];
    this.mobileCategoriesOpen.set(false);
    this.onCategoryChange(updated);
  }

  viewAllItems(): void {
    this.mobileCategoriesOpen.set(false);
    if (!this.filters().categoryId.length && !this.filters().dynamicCategory) return;
    this.filters.update(f => {
      const updated = { ...f, categoryId: [] as number[], dynamicCategory: '', page: 1 };
      this.paginatorService.setFilters(updated);
      return updated;
    });
    this.firstSignal.set(0);
    this.apiService.getItemList('auctions', this.id!, this.filters()).subscribe();
  }

  selectDynamicFromSidebar(key: string): void {
    const current = this.filters().dynamicCategory;
    this.mobileCategoriesOpen.set(false);
    this.onCategoryDynamicChange(current === key ? '' : key);
  }

  onCategoryDynamicChange(selectedCategoriesDynamic: string): void {

    this.filters.update(filters => {
      const updateFilters = {
        ...filters,
        dynamicCategory: selectedCategoriesDynamic,
        page: 1,
        categoryId: []
      };
      this.paginatorService.setFilters(updateFilters);

      const first = (updateFilters.page - 1) * updateFilters.per;
      this.firstSignal.set(first);
      return updateFilters;


    });

    const endpoint = 'auctions';
    this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
  }

  onSearch(search: string): void {
    this.inputSearch = search;
    const currentQuery = this.filters().q;
    // console.log('search');
    if (currentQuery !== search) {


      this.filters.update(filters => ({
        ...filters,
        q: search,
        page: 1
      }));

      this.searchCounter.update(c => c + 1);

      const endpoint = 'auctions';
      this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
    }
  }


  clearFilters(): void {

    this.resetFilters();
    this.firstSignal.set(0);
    this.paginatorService.setPagination(1, 30);
    this.selectedSortSignal.set(this.defaultItemsSort());
    this.paginatorService.clearFilters();
    this.inputSearch = null;

    this.rowsPerPage = 30
    const endpoint = 'auctions';
    this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
  }

  //views
  toggleView(mode: 'image' | 'list') {
    // console.log(mode);
    this.viewMode = mode;
  }

  onPageChange(event: any) {
    this.filters.update(filters => ({
      ...filters,
      page: event.page + 1,
      per: event.rows
    }));

    this.firstSignal.set(event.first);

    this.paginatorService.setPagination(event.page + 1, event.rows);

    this.pagination = {
      page: event.page + 1,
      per: event.rows
    };

    this.apiService.getItemList('auctions', this.id!, this.filters()).subscribe();
  }


  get paginatorItems(): IItem[] {
    return this.itemList;
  }


  //delete
  onBidCompleted() {
    const endpoint = 'auctions';
    this.apiService.getItemList(endpoint, this.id!, this.filters());
  }

  onModalStatusChanged(status: { refreshNeeded: boolean }) {
    if (status.refreshNeeded) {
      const endpoint = 'auctions';
      this.apiService.getItemList(endpoint, this.id!, this.filters()).subscribe();
    }
  }

  public hideOnMobile(categoryFilter: MultiSelect) {
    if (window != undefined) {
      if (window.innerWidth < MD_BREAKPOINT) {
        categoryFilter.hide();
      }
    }
  }

  private toUrlSafeBase64(input: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (input != undefined && input != null && input.length > 0) {
        return window.btoa(input).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      }
    }
    return "";
  }

  private fromUrlSafeBase64(encoded: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (encoded != undefined && encoded != null && encoded.length > 0) {
        let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4 !== 0) {
          base64 += '=';
        }
        return window.atob(base64);
      }
    }
    return "[]";
  }
}